import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ShopDto, UpdateOneShopNotificationDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";

export default function useUpdateShopifyPreferenceNotifications(shop: ShopDto) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const invalidateShop = useInvalidateShop(shop.id);

  const mutation = $api.useMutation("patch", "/shops/{shopId}/preferences/notifications");

  return useMutation({
    onError: () => {
      errorNotification();
    },
    onSuccess: () => {
      invalidateShop();
      successNotification();
    },
    mutationFn: async (data: UpdateOneShopNotificationDto) => {
      return mutation.mutateAsync({
        params: { path: { shopId: shop.id } },
        body: data,
      });
    },
  });
}
